module.exports = __webpack_public_path__ + "jira-3-7418d8d6750bb1db649f9ed1a75c5146.webp";